import React from "react";
import List from "./List";
import {useRoutes} from "hookrouter";
import {addEventGroup, removeEventGroup, updateEventGroup, useEventGroup} from "../../../../Api/events";
import debug from "../../../../Lib/debug";
import Form from "./Form";
import {EventGroupRecord, EventGroupSchema} from "../../../../Data/Event";
import {useTranslation} from "react-i18next";

export default (props) => useRoutes(subRoutes)(props)

const subRoutes = {
  "/": () => (props) => <Groups view="list" {...props}/>,
  "/add": () => (props) => <Groups view="add" {...props}/>,
  "/:id/edit": ({id}) => (props) => <Groups view="edit" {...props} id={id}/>,
  "/:id/remove": ({id}) => (props) => <Groups view="remove" {...props} id={id}/>
};


const Groups = ({view, id, eventId, path}) => {

  debug("RENDER", "Events.Groups", () => []);

  const {loadingStatus, data} = useEventGroup(eventId, id);

  const prefix = "/admin/events/" + eventId + "/groups/";

  const viewData = (loadingStatus ? new EventGroupRecord(EventGroupSchema.default()) : data);

  const {t} = useTranslation('event');

  const label = (view === 'add' ? t('add-group') : viewData.get('name'));

  const np = path.slice(0); // to avoid modifying parent path

  switch (view) {
    case "list" :

      return <List eventId={eventId} path={np}/>;

    case "add" :

      np.push({label: label, url: prefix + "add"});
      return <Form eventId={eventId} id={id} record={viewData.set('event', eventId)} path={np} view={view} api={addEventGroup}/>;

    case "remove" :

      np.push({label: label, url: prefix + id + "/remove"});
      return <Form eventId={eventId} id={id} record={viewData} path={np} view={view} api={removeEventGroup}/>;

    case "edit" :

      np.push({label: label, url: prefix + id + "/edit"});
      return <Form eventId={eventId} id={id} record={viewData} path={np} view={view} api={updateEventGroup}/>;

    default :
      return <div>invalid view: {view}</div>
  }
};